// extracted by mini-css-extract-plugin
export default {"Container":"ShipmentList_Container__qllwD","ContainerCompact":"ShipmentList_ContainerCompact__f6+Q7","EmptyState":"ShipmentList_EmptyState__MYgoi"};